import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../../store/actions';
import DataConfig from '../../../data';
import { getRequestQuery, getNextView, runRequestHook, runResponseHook, persistViewState } from '../util';
import getPrettyError from '../../../utils/getPrettyError';
export default (function (props) {
  return function (dispatch, getState) {
    var id = props.id,
        dataType = props.dataType;
    if (!id) throw new Error('DataGrid id is required when performing a load');
    var store = getState();
    var view = store.grid.views[id];
    var nextView = getNextView(id, view, props);
    var requestAction = getRequestQuery(nextView, props);
    requestAction.type = 'loadView';
    requestAction = runRequestHook(nextView.onBeforeRequest, props, requestAction, undefined, dataType && DataConfig[dataType]);
    var sliceRange = {
      start: nextView.page * nextView.itemsPerPage,
      count: nextView.itemsPerPage
    };
    nextView.isLoading = props.silent ? false : true;
    nextView.startedLoadingAt = Date.now();
    persistViewState(nextView);
    return dispatch({
      type: ACTIONS.GRID_DATA_GET,
      view: nextView,
      request: requestAction,
      sliceRange: sliceRange
    }).then(function (_ref) {
      var body = _ref.body,
          type = _ref.type,
          payload = _ref.payload;
      if (type === 'AUTH_SET_UNAUTHORIZED') throw payload;
      nextView = _objectSpread({}, nextView, {
        isLoading: false,
        lastLoadingTook: Date.now() - nextView.startedLoadingAt,
        all: undefined,
        fullyLoaded: undefined
      });

      if (body) {
        body = runResponseHook(nextView.onAfterResponse, props, requestAction, body);
        persistViewState(nextView);
        var refreshedAction = {
          type: ACTIONS.GRID_DATA_GET_RESOLVED,
          view: nextView,
          payload: body,
          sliceRange: sliceRange
        };
        var refreshedEv = new CustomEvent('data-grid-refresh-resolved', {
          detail: refreshedAction
        });
        document.dispatchEvent(refreshedEv);
        return dispatch(refreshedAction);
      }
    }).catch(function (error) {
      nextView = _objectSpread({}, nextView, {
        isLoading: false
      });
      persistViewState(nextView);
      return dispatch({
        type: ACTIONS.GRID_DATA_GET_FAILED,
        view: nextView,
        payload: {
          error: error.message,
          text: getPrettyError(error),
          status: error.status
        },
        sliceRange: sliceRange
      });
    });
  };
});